import { motion } from "framer-motion";
import { PlayCircle, Table, ListChecks } from "lucide-react";

const ITEMS = [
  {
    icon: PlayCircle,
    title: "Videoaulas gravadas",
    text: "Explicação completa de cada fase, assistidas no seu ritmo, quantas vezes precisar.",
  },
  {
    icon: Table,
    title: "Tabelas por faixa etária",
    text: "Sem precisar lembrar de cabeça o que fazer em cada fase do desenvolvimento.",
  },
  {
    icon: ListChecks,
    title: "Passo a passo dos métodos",
    text: "Instruções detalhadas para cada abordagem de autonomia ensinada no Módulo 4.",
  },
];

export default function SupportSection() {
  return (
    <section className="py-20 lg:py-24 bg-[#fbf6ed]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid sm:grid-cols-3 gap-5 items-stretch">
          {ITEMS.map((it, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="h-full rounded-3xl border border-[#e0d4ec] bg-white/70 p-6 hover:border-violet-400/30 transition-colors duration-500 flex flex-col"
            >
              <div className="w-11 h-11 rounded-2xl bg-violet-400/15 flex items-center justify-center mb-5">
                <it.icon className="w-5 h-5 text-[#6d28d9]" strokeWidth={1.5} />
              </div>
              <h3 className="text-[#1f1430] font-semibold text-base mb-2 min-h-[3rem] leading-snug">
                {it.title}
              </h3>
              <p className="text-[#6b5e7c] text-sm leading-relaxed">{it.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
